// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import track from './eventTracker';

const AllSizesTracker = new (function () {
  this.trackRecommendedSizesTabClickEvent = ({
    collection = null,
    outfitId = null,
    productSkuId,
    source,
    externalProductId,
  }) =>
    track({
      action_name: 'click_recommended_sizes',
      action_type: 'click',
      canonical_name: 'pdp',
      collection,
      event_name: 'pdp.all_sizes.interaction',
      outfit_id: outfitId,
      sku_id: productSkuId,
      source,
      external_product_id: externalProductId,
    });

  this.trackAllSizesTabClickEvent = ({
    collection = null,
    outfitId = null,
    productSkuId,
    externalProductId,
    source,
  }) =>
    track({
      action_name: 'click_all_sizes',
      action_type: 'click',
      canonical_name: 'pdp',
      collection,
      event_name: 'pdp.all_sizes.interaction',
      outfit_id: outfitId,
      sku_id: productSkuId,
      source,
      external_product_id: externalProductId,
    });

  this.trackStyleProfileCtaClickEvent = ({
    collection = null,
    outfitId = null,
    productSkuId,
    source,
    externalProductId,
  }) =>
    track({
      action_name: 'click_style_profile_cta',
      action_type: 'click',
      canonical_name: 'pdp',
      collection,
      event_name: 'pdp.all_sizes.interaction',
      outfit_id: outfitId,
      sku_id: productSkuId,
      source,
      external_product_id: externalProductId,
    });

  this.trackInventoryAvailabilityEvent = ({
    collection = null,
    outfitId = null,
    productSkuId,
    source,
    skus,
    externalProductId,
  }) => {
    const allItemsOutOfStock = skus.every(
      sku => sku.inventory.availability === 'OUT_OF_STOCK',
    );
    const formattedSkus = skus.map(sku => ({
      out_of_stock: sku.inventory.availability === 'OUT_OF_STOCK',
      sku_id: sku.id,
    }));

    return track({
      action_name: 'oos_rate',
      action_type: 'page_view',
      all_items_out_of_stock: allItemsOutOfStock,
      canonical_name: 'pdp',
      collection,
      event_name: 'pdp.all_sizes.view',
      outfit_id: outfitId,
      source,
      sku_id: productSkuId,
      skus: formattedSkus,
      external_product_id: externalProductId,
    });
  };
})();

export default AllSizesTracker;
